import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnListDefinition } from 'src/app/controls/advanced-gridview/models/column-list-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { ListItem } from 'src/app/controls/filters/models/list-item';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { DocumentType } from 'src/app/models/document-type';
import { Rights } from 'src/app/models/enums/rights';
import { BoxesService } from 'src/app/services/boxes.service';
import { DocumentTypesService } from 'src/app/services/document-type.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';

@Component({
    selector: 'app-document-types-list',
    templateUrl: './document-types-list.component.html',
    styleUrls: ['./document-types-list.component.scss'],
    imports: [AdvancedGridviewComponent]
})
export class DocumentTypesListComponent extends DefaultListComponent<DocumentType> implements OnInit {
    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param enumHelper : Classe utilitaire pour les énumérations.
     * @param documentTypesService : Service de gestion des types de document.
     * @param boxesService : Service de gestion des bannettes.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        public enumHelper: EnumHelper,
        private documentTypesService: DocumentTypesService,
        private boxesService: BoxesService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        // Specifie des colonnes en fonction des droits utilisateurs
        if (this.memoryService.getConnectedUser().params.idVisible === true) {
            this.tableConfig = [
                new ColumnDefinition('id', 'Id', ColumnType.Numeric, FilterType.Text, 1, 5, true),
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 65, true),
                new ColumnListDefinition('defaultBoxId', 'bannette par défaut', FilterType.List, 3, 25, true, false),
            ];
        } else {
            this.tableConfig = [
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 70, true),
                new ColumnListDefinition('defaultBoxId', 'bannette par défaut', FilterType.List, 3, 25, true, false),
            ];
        }

        this.AddMenuItem('Dupliquer', MenuITemAction.Duplicate, Rights.DocumentTypeCreate);
        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.DocumentTypeEdit);
        this.AddMenuItem('Supprimer', MenuITemAction.Delete, Rights.DocumentTypeDelete);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        this.dataSource = new AdvancedDataSource(null, this.documentTypesService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('name', 'asc'));

        // Ajout des listes déroulantes
        // attente de 500ms pour que la gridView ait le temps de se remplir.
        setTimeout(() => {
            this.loadListColumnFilterDatas();
        }, 500);
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<DocumentType>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(event.context);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(event.context);
        } else if (event.action == MenuITemAction.Duplicate) {
            // Cas de duplication.
            this.itemDuplicated.emit(event.context);
        } else if (event.action == MenuITemAction.Delete) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de supprimer le type de document '${event.context.name}'.`, event.context);
        }
    }

    /**
     * Charge les éléments des filtres des colonnes de type liste.
     */
    private loadListColumnFilterDatas(): void {
        this.boxesService.ListForOrganisation(null, null, null, null).subscribe((x) => {
            var listItem = x.value.map<ListItem<string>>((v) => <ListItem<string>>{ value: v.id.toString(), text: v.name });
            this.loadColumn(
                this.filteredTableModel.displayedColumnsDefinitions.find(
                    (x) => this.enumHelper.areEquals(ColumnType, x.type, ColumnType.List) && x.columnName === 'defaultBoxId'
                ) as ColumnListDefinition<string>,
                listItem
            );
        });
    }
}
